/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */
import * as Types from 'src/graphql.generated'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

const defaultOptions = {} as const
export type GetAdvancedPatientTagsQueryVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
}>

export type GetAdvancedPatientTagsQuery = {
  __typename?: 'Query'
  patient: {
    __typename?: 'Patient'
    uid: string
    tags?: Array<{ __typename?: 'PatientTag'; id: string; name: string }> | null
  }
}

export type GetAdvancedAllTagsQueryVariables = Types.Exact<{ [key: string]: never }>

export type GetAdvancedAllTagsQuery = {
  __typename?: 'Query'
  patientTags: Array<{ __typename?: 'PatientTag'; id: string; name: string }>
}

export type AddAdvancedTagToParticipantMutationVariables = Types.Exact<{
  tagID: Types.Scalars['ID']['input']
  uid: Types.Scalars['ID']['input']
}>

export type AddAdvancedTagToParticipantMutation = {
  __typename?: 'Mutation'
  addTagToPatient?: { __typename?: 'AddTagToPatientAction'; uid: string; tagID: string } | null
}

export type RemoveAdvancedTagFromParticipantMutationVariables = Types.Exact<{
  tagID: Types.Scalars['ID']['input']
  uid: Types.Scalars['ID']['input']
}>

export type RemoveAdvancedTagFromParticipantMutation = { __typename?: 'Mutation'; removeTagFromPatient?: null | null }

export const GetAdvancedPatientTagsDocument = gql`
  query getAdvancedPatientTags($uid: ID!) {
    patient(uid: $uid) {
      uid
      tags {
        id
        name
      }
    }
  }
`

/**
 * __useGetAdvancedPatientTagsQuery__
 *
 * To run a query within a React component, call `useGetAdvancedPatientTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvancedPatientTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvancedPatientTagsQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGetAdvancedPatientTagsQuery(
  baseOptions: Apollo.QueryHookOptions<GetAdvancedPatientTagsQuery, GetAdvancedPatientTagsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAdvancedPatientTagsQuery, GetAdvancedPatientTagsQueryVariables>(
    GetAdvancedPatientTagsDocument,
    options
  )
}
export function useGetAdvancedPatientTagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAdvancedPatientTagsQuery, GetAdvancedPatientTagsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAdvancedPatientTagsQuery, GetAdvancedPatientTagsQueryVariables>(
    GetAdvancedPatientTagsDocument,
    options
  )
}
export type GetAdvancedPatientTagsQueryHookResult = ReturnType<typeof useGetAdvancedPatientTagsQuery>
export type GetAdvancedPatientTagsLazyQueryHookResult = ReturnType<typeof useGetAdvancedPatientTagsLazyQuery>
export type GetAdvancedPatientTagsQueryResult = Apollo.QueryResult<
  GetAdvancedPatientTagsQuery,
  GetAdvancedPatientTagsQueryVariables
>
export const GetAdvancedAllTagsDocument = gql`
  query getAdvancedAllTags {
    patientTags {
      id
      name
    }
  }
`

/**
 * __useGetAdvancedAllTagsQuery__
 *
 * To run a query within a React component, call `useGetAdvancedAllTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvancedAllTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvancedAllTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdvancedAllTagsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetAdvancedAllTagsQuery, GetAdvancedAllTagsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAdvancedAllTagsQuery, GetAdvancedAllTagsQueryVariables>(GetAdvancedAllTagsDocument, options)
}
export function useGetAdvancedAllTagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAdvancedAllTagsQuery, GetAdvancedAllTagsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAdvancedAllTagsQuery, GetAdvancedAllTagsQueryVariables>(
    GetAdvancedAllTagsDocument,
    options
  )
}
export type GetAdvancedAllTagsQueryHookResult = ReturnType<typeof useGetAdvancedAllTagsQuery>
export type GetAdvancedAllTagsLazyQueryHookResult = ReturnType<typeof useGetAdvancedAllTagsLazyQuery>
export type GetAdvancedAllTagsQueryResult = Apollo.QueryResult<
  GetAdvancedAllTagsQuery,
  GetAdvancedAllTagsQueryVariables
>
export const AddAdvancedTagToParticipantDocument = gql`
  mutation addAdvancedTagToParticipant($tagID: ID!, $uid: ID!) {
    addTagToPatient(tagID: $tagID, uid: $uid) {
      uid
      tagID
    }
  }
`
export type AddAdvancedTagToParticipantMutationFn = Apollo.MutationFunction<
  AddAdvancedTagToParticipantMutation,
  AddAdvancedTagToParticipantMutationVariables
>

/**
 * __useAddAdvancedTagToParticipantMutation__
 *
 * To run a mutation, you first call `useAddAdvancedTagToParticipantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAdvancedTagToParticipantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAdvancedTagToParticipantMutation, { data, loading, error }] = useAddAdvancedTagToParticipantMutation({
 *   variables: {
 *      tagID: // value for 'tagID'
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useAddAdvancedTagToParticipantMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddAdvancedTagToParticipantMutation,
    AddAdvancedTagToParticipantMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<AddAdvancedTagToParticipantMutation, AddAdvancedTagToParticipantMutationVariables>(
    AddAdvancedTagToParticipantDocument,
    options
  )
}
export type AddAdvancedTagToParticipantMutationHookResult = ReturnType<typeof useAddAdvancedTagToParticipantMutation>
export type AddAdvancedTagToParticipantMutationResult = Apollo.MutationResult<AddAdvancedTagToParticipantMutation>
export type AddAdvancedTagToParticipantMutationOptions = Apollo.BaseMutationOptions<
  AddAdvancedTagToParticipantMutation,
  AddAdvancedTagToParticipantMutationVariables
>
export const RemoveAdvancedTagFromParticipantDocument = gql`
  mutation removeAdvancedTagFromParticipant($tagID: ID!, $uid: ID!) {
    removeTagFromPatient(tagID: $tagID, uid: $uid)
  }
`
export type RemoveAdvancedTagFromParticipantMutationFn = Apollo.MutationFunction<
  RemoveAdvancedTagFromParticipantMutation,
  RemoveAdvancedTagFromParticipantMutationVariables
>

/**
 * __useRemoveAdvancedTagFromParticipantMutation__
 *
 * To run a mutation, you first call `useRemoveAdvancedTagFromParticipantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAdvancedTagFromParticipantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAdvancedTagFromParticipantMutation, { data, loading, error }] = useRemoveAdvancedTagFromParticipantMutation({
 *   variables: {
 *      tagID: // value for 'tagID'
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useRemoveAdvancedTagFromParticipantMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveAdvancedTagFromParticipantMutation,
    RemoveAdvancedTagFromParticipantMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RemoveAdvancedTagFromParticipantMutation,
    RemoveAdvancedTagFromParticipantMutationVariables
  >(RemoveAdvancedTagFromParticipantDocument, options)
}
export type RemoveAdvancedTagFromParticipantMutationHookResult = ReturnType<
  typeof useRemoveAdvancedTagFromParticipantMutation
>
export type RemoveAdvancedTagFromParticipantMutationResult =
  Apollo.MutationResult<RemoveAdvancedTagFromParticipantMutation>
export type RemoveAdvancedTagFromParticipantMutationOptions = Apollo.BaseMutationOptions<
  RemoveAdvancedTagFromParticipantMutation,
  RemoveAdvancedTagFromParticipantMutationVariables
>
